export default "__VITE_ASSET__LiSNmlkc__"